import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { createStore, Provider } from 'jotai';

/**
 * Test-only: Jotai Provider with an isolated store, so state doesn't leak between tests.
 * The apps use Jotai's default store and must not be wrapped in this.
 * `initializeState(store)` runs once before the first render to seed atoms via `store.set(atom, value)`.
 */
export const JotaiStoreProvider = ({ initializeState, children }) => {
  const [store] = useState(() => {
    const newStore = createStore();
    initializeState?.(newStore);
    return newStore;
  });
  return <Provider store={store}>{children}</Provider>;
};

JotaiStoreProvider.propTypes = {
  initializeState: PropTypes.func,
  children: PropTypes.node
};
